const DoctorProfileInitialFormBO = {
    createBaseInitialForm() {
        return {
            patientContactPhone1: '',
            patientContactPhone2: '',
            consultationCost: '',
            examCost: '',
            paymentMethods: [
                { identifier: 'cash', checked: false, label: 'Efectivo' },
                { identifier: 'creditCard', checked: false, label: 'Tarjeta de Crédito' },
                { identifier: 'transfers', checked: false, label: 'Transferencias' },
                { identifier: 'bitcoin', checked: false, label: 'Bitcoin' },
                { identifier: 'remesa', checked: false, label: 'Remesa' }
            ],
            governmentPermitInfo: '',
            addresses: '',
            latitudeAndLongitude: '',
            generalInfo: '',
            insurance: '',
            idCity: '',
            idSpecialty: '',
            conademNumber: ''
        };
    },
    translateBasicProfile(basicForm) {

        const cashChecked = basicForm.paymentMethods && basicForm.paymentMethods.includes('Efectivo');
        const creditCardChecked = basicForm.paymentMethods && basicForm.paymentMethods.includes('Tarjeta de Crédito');
        const transfersChecked = basicForm.paymentMethods && basicForm.paymentMethods.includes('Transferencias');
        const bitcoinChecked = basicForm.paymentMethods && basicForm.paymentMethods.includes('Bitcoin');
        const remesaChecked = basicForm.paymentMethods && basicForm.paymentMethods.includes('Remesa');

        const latitudeAndLongitude =
            basicForm.latitude && basicForm.longitude ? `${basicForm.latitude}, ${basicForm.longitude}` : '';

        return {
            patientContactPhone1: basicForm.patientContactPhone1,
            patientContactPhone2: basicForm.patientContactPhone2 || '',
            patientContactPhone1CountryCode: basicForm.patientContactPhone1CountryCode || '',
            patientContactPhone2CountryCode: basicForm.patientContactPhone2CountryCode || '',
            consultationCost: basicForm.consultationCost,
            examCost: basicForm.examCost || '',
            conademNumber: basicForm.conademNumber || '',
            cash: cashChecked,
            creditCard: creditCardChecked,
            transfers: transfersChecked,
            bitcoin: bitcoinChecked,
            remesa: remesaChecked,
            governmentPermitInfo: basicForm.governmentPermitInfo || '',
            addresses: Array.isArray(basicForm.addresses) && basicForm.addresses.length > 0
                ? basicForm.addresses
                : undefined,

            latitudeAndLongitude,
            generalInfo: basicForm.generalInfo || '',
            insurance: basicForm.insurance || '',
            idCity: basicForm.idCity || '',
            idSpecialty: basicForm.idSpecialty || ''
        };
    },
    insertInObject(key, value, editableObject) {
        const newObject = { ...editableObject };
        newObject[key] = value;
        return newObject;
    },
    prepareSaveObject(basicForm) {
        //check for validity
        const paymentMethods = [];

        if (basicForm.remesa) paymentMethods.push('Remesa');
        if (basicForm.transfers) paymentMethods.push('Transferencias');
        if (basicForm.bitcoin) paymentMethods.push('Bitcoin');
        if (basicForm.creditCard) paymentMethods.push('Tarjeta de Crédito');
        if (basicForm.cash) paymentMethods.push('Efectivo');

        const paymentMethodString = paymentMethods.length > 0 ? paymentMethods.join(', ') : false;

        let [latitude, longitude] = basicForm.latitudeAndLongitude.split(',');

        if (!latitude || latitude === '') {
            latitude = null;
        }

        if (!longitude || longitude === '') {
            longitude = null;
        }

        let idCity = parseInt(basicForm.idCity);
        let idSpecialty = parseInt(basicForm.idSpecialty);

        if (!idCity || idCity < 1) {
            return false;
        }

        if (!idSpecialty || idSpecialty < 1) {
            return false;
        }

        console.log('Business Object - Phone 1:', basicForm.patientContactPhone1, 'Country Code 1:', basicForm.patientContactPhone1CountryCode);
        console.log('Business Object - Phone 2:', basicForm.patientContactPhone2, 'Country Code 2:', basicForm.patientContactPhone2CountryCode);
        
        return {
            patientContactPhone1: basicForm.patientContactPhone1,
            ...(basicForm.patientContactPhone1CountryCode && { patientContactPhone1CountryCode: basicForm.patientContactPhone1CountryCode }),
            ...(basicForm.patientContactPhone2 && { patientContactPhone2: basicForm.patientContactPhone2 }),
            ...(basicForm.patientContactPhone2CountryCode && { patientContactPhone2CountryCode: basicForm.patientContactPhone2CountryCode }),
            consultationCost: basicForm.consultationCost,
            ...(basicForm.examCost && { examCost: basicForm.examCost }),
            ...(basicForm.conademNumber && { conademNumber: basicForm.conademNumber }),
            paymentMethods: paymentMethodString,
            ...(basicForm.governmentPermitInfo && { governmentPermitInfo: basicForm.governmentPermitInfo }),
            ...(basicForm.generalInfo && { generalInfo: basicForm.generalInfo }),
            ...(basicForm.insurance && { insurance: basicForm.insurance }),
            addresses: Array.isArray(basicForm.addresses) ? basicForm.addresses : undefined,
            ...(latitude && { latitude: latitude.trim() }),
            ...(longitude && { longitude: longitude.trim() }),
            idCity,
            idSpecialty
        };
    }
};

export default DoctorProfileInitialFormBO;
